module.exports = __webpack_public_path__ + "img/stepTwo.efc8e689.jpg";